import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import React from "react";
import Button from '../../components/CustomButtons/Button';
// nodejs library to set properties for components

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// material-ui icons
import MoreVert from "@material-ui/icons/MoreVert";


import { unwrapResult } from "@reduxjs/toolkit";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarStyle.js";
import buttonStyles from "assets/jss/material-dashboard-pro-react/components/buttonStyle.js";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  deleteFacilitiesRequired,
  fetchFacilitiesRequireds
} from "../../reduxToolkit/features/FacilitiesRequired/FacilitiesRequiredSlice";

import { useTranslation } from "react-i18next";
import GeneralDeleteModal from '../Components/GeneralDeleteModal';
const useStyles = makeStyles(styles);
const useButtonStyles = makeStyles(buttonStyles);

export default function DropDownButtonFR(props) {
  const { t } = useTranslation();
  const buttonClasses = useButtonStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };
  const dispatch = useDispatch();
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
    console.log("res");
    console.log(props.courseID);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };
  const classes = useStyles();

  const delete_FacilitiesRequired = (id) => {
    dispatch(deleteFacilitiesRequired(id))
      .then(unwrapResult)
      .then((originalPromiseResult) => {
        // handle result here
        console.log("originalPromiseResult", originalPromiseResult);
      })
      .then(() => {
        // do additional work
        dispatch(fetchFacilitiesRequireds(props.courseID));
      })
      .catch((rejectedValueOrSerializedError) => {
        // handle error here
        console.log(
          "rejectedValueOrSerializedError",
          rejectedValueOrSerializedError
        );
      });
  };

  return (
    <span>
      <Button
        color="primary"
        round
        ref={anchorRef}
        aria-controls={open ? "split-button-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-label="select merge strategy"
        aria-haspopup="menu"
        onClick={handleToggle}
        className={`${buttonClasses.justIcon} ${buttonClasses.round}`}
      >
        <MoreVert />
      </Button>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu">
                  <MenuItem>
                    <Link
                      to={`/citrine/specification/course/${props.courseID}/FacilitiesRequireds/${props.FacilitiesRequired_ID}/edit`}
                    >
                      Edit
                    </Link>
                  </MenuItem>


                  <MenuItem>

                    <GeneralDeleteModal
                      delete_Element={delete_FacilitiesRequired}
                      Element_ID={props.FacilitiesRequired_ID}
                    />
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </span>
  );
}
